import React, { useState, useRef, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleOutlineOutlined from '@mui/icons-material/CheckCircleOutlineOutlined';
import { Constantes, RouterUtils, RetailCompassStorage } from '@common/utils';
import moment from 'moment';


const IncidentIndicator = ({ storeId, history }) => {

    const incident = RetailCompassStorage.getIncidentByStoreId(storeId);

    const [isOpen, setIsOpen] = useState(false);
    const targetRef = useRef(null);
    const isHovering = useRef(false); 
    const timeoutRef = useRef(null);
    const TIMEOUT_DELAY_MS = 500;

    const currentModule = RetailCompassStorage.isStoreTypeBrand() 
    ? RouterUtils.MODULES.BRAND 
    : RouterUtils.MODULES.RETAIL;

    const isIncidentOpen = incident?.statusId === Constantes.INCIDENT_STATUS_ID.OPEN;
    const isClosed = incident?.statusId === Constantes.INCIDENT_STATUS_ID.CLOSED;

    const onClickIncident = (e) => {
        e.preventDefault();
        history.push(`${currentModule}/${RouterUtils.MODULES_VIEWS.HEALTH}`);
    };

    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        isHovering.current = true;
        setIsOpen(true);
    };


    const handleMouseLeave = () => {
        isHovering.current = false;
        timeoutRef.current = setTimeout(() => {
            if (!isHovering.current) {
                setIsOpen(false);
            }
        }, TIMEOUT_DELAY_MS);
    };

    const handlePopoverMouseEnter = () => {
        isHovering.current = true;
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    if (!incident || incident.statusId === Constantes.INCIDENT_STATUS_ID.DEFAULT) {
        return null;
    }

    return (
        <div 
            className="incident-indicator-container"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave} 
        >
            <div 
                ref={targetRef}
                className={`incident-indicator__icon ${isClosed ? 'incident-indicator__icon--resolved' : 'incident-indicator__icon--open'}`}
                data-testid="incident-indicator-icon"
            >
                {isClosed ? <CheckCircleOutlineOutlined /> : <WarningAmberIcon />}
            </div>
            
            {isOpen && (
                <Popover
                    placement="top"
                    isOpen={isOpen}
                    target={targetRef}
                    toggle={() => {}}
                    className="incident-indicator-popover"
                    trigger="legacy"
                    hideArrow
                >

                    <div 
                        onMouseEnter={handlePopoverMouseEnter} 
                        onMouseLeave={handleMouseLeave}
                        style={{ display: 'block' }}
                    >
                        <PopoverHeader className="incident-indicator__header">
                            {isIncidentOpen && 'Incidente abierto en'} <strong>{incident.storeName}</strong>
                        </PopoverHeader>
                        <PopoverBody>
                            <div className="incident-indicator__content">
                                <div className="incident-indicator__date">
                                    Última comunicación{' '}
                                    {moment.utc(incident.lastUpdate).locale('es').fromNow()}:
                                </div>
                                <div className="incident-indicator__message incident-indicator__body">
                                    {incident.lastMessage}
                                </div>
                                <div 
                                    className="incident-indicator__link" 
                                    onClick={onClickIncident}
                                    role="button"
                                    tabIndex={0}
                                >
                                    Ver estado de actualización de datos
                                </div>
                            </div>
                        </PopoverBody>
                    </div>
                </Popover>
            )}
        </div>
    );
};

IncidentIndicator.propTypes = {
    storeId: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object,
    match: PropTypes.object
};

export default withRouter(IncidentIndicator);